export const useIsLogin = () => {
  if (localStorage.getItem('access_token')) return true
  else false
}
